/**
 * 倒计时工具函数
 * 用于管理倒计时逻辑，提供开始、停止、格式化等功能
 */

/**
 * 格式化时间为 HH:MM:SS 格式
 * @param {number} seconds - 秒数
 * @returns {object} 包含时、分、秒的对象
 */
export function formatTime(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
   return {
    h: h.toString().padStart(2, "0"),
    m: m.toString().padStart(2, "0"),
    s: s.toString(),
  };
  // return {
  //   h: h.toString().padStart(2, "0"),
  //   m: m.toString().padStart(2, "0"),
  //   s: s.toString().padStart(2, "0"),
  // };
}

/**
 * 创建倒计时管理器
 * @param {object} options - 配置选项
 * @param {number} options.initialTime - 初始倒计时时间（秒）
 * @param {function} options.onUpdate - 每秒更新回调
 * @param {function} options.onEnd - 倒计时结束回调
 * @returns {object} 倒计时管理器实例
 */
export function createCountdown(options = {}) {
  const {
    initialTime = 3600,
    onUpdate = () => {},
    onEnd = () => {}
  } = options;

  let countdownTime = initialTime;
  let countdownInterval = null;

  return {
    /**
     * 开始倒计时
     */
    start() {
      if (countdownInterval) {
        this.stop();
      }

      countdownInterval = setInterval(() => {
        if (countdownTime > 0) {
          countdownTime--;
          onUpdate(formatTime(countdownTime));
        } else {
          this.stop();
          onEnd();
        }
      }, 1000);
    },

    /**
     * 停止倒计时
     */
    stop() {
      if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
      }
    },

    /**
     * 重置倒计时
     * @param {number} time - 新的倒计时时间（秒）
     */
    reset(time = initialTime) {
      this.stop();
      countdownTime = time;
    },

    /**
     * 获取当前剩余时间
     * @returns {number} 剩余秒数
     */
    getRemainingTime() {
      return countdownTime;
    },

    /**
     * 获取当前格式化的时间
     * @returns {object} 格式化后的时间对象
     */
    getFormattedTime() {
      return formatTime(countdownTime);
    }
  };
}
